import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";

type WebActionSheetProps = {
  visible: boolean;
  onClose: () => void;
  options: string[];
  onSelect: (index: number) => void;
  cancelButtonIndex?: number;
  destructiveButtonIndex?: number;
};

export const WebActionSheet = ({
  visible,
  onClose,
  options,
  onSelect,
  cancelButtonIndex,
  destructiveButtonIndex,
}: WebActionSheetProps) => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    if (visible) {
      const timer = setTimeout(() => setAnimate(true), 10);
      return () => clearTimeout(timer);
    } else {
      setAnimate(false);
    }
  }, [visible]);

  if (!visible) return null;

  return createPortal(
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        zIndex: 2000,
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
        opacity: animate ? 1 : 0,
        transition: "opacity 0.3s ease-out",
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: "white",
          borderTopLeftRadius: 12,
          borderTopRightRadius: 12,
          padding: 16,
          paddingBottom: 32,
          display: "flex",
          flexDirection: "column",
          gap: 8,
          maxWidth: 600,
          width: "100%",
          margin: "0 auto",
          boxSizing: "border-box",
          transform: animate ? "translateY(0)" : "translateY(100%)",
          transition: "transform 0.3s cubic-bezier(0.33, 1, 0.68, 1)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {options.map((option, index) => {
          const isDestructive = index === destructiveButtonIndex;
          const isCancel = index === cancelButtonIndex;
          return (
            <button
              key={index}
              onClick={() => {
                onSelect(index);
                onClose();
              }}
              style={{
                padding: 16,
                borderRadius: 8,
                backgroundColor: isCancel ? "#f0f0f0" : "white",
                border: isCancel ? "none" : "1px solid #eee",
                fontSize: 16,
                fontWeight: isCancel ? "bold" : "normal",
                color: isDestructive ? "red" : "black",
                cursor: "pointer",
                textAlign: "center",
                width: "100%",
              }}
            >
              {option}
            </button>
          );
        })}
      </div>
    </div>,
    document.body,
  );
};
